var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#D61F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2472 7.51662L22.4834 13.7528C23.1722 14.4416 23.1722 15.5584 22.4834 16.2472L16.2472 22.4834C15.5584 23.1722 14.4416 23.1722 13.7528 22.4834L7.51662 16.2472C6.82779 15.5584 6.82779 14.4416 7.51662 13.7528L13.7528 7.51662C14.4416 6.82779 15.5584 6.82779 16.2472 7.51662ZM16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18ZM14.9897 12H15.0101C15.621 12.0074 16.0826 12.5924 15.9876 13.244L15.5599 15.4817C15.5192 15.7779 15.2816 16 15.0033 16H14.9965C14.7182 16 14.4807 15.7779 14.4399 15.4817L14.0123 13.244C13.9173 12.5924 14.3856 12 14.9897 12Z",
    fill: "#D61F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomplete);
export default __webpack_public_path__ + "static/media/Incomplete.a5ef99ef0667936d7b72c2fd4c5a0a48.svg";
export { ForwardRef as ReactComponent };